<template>
  <ul class="usp-list" v-if="usps">
    <li class="usp-list__item mb-1" v-for="usp in usps" :key="usp">
      <icon identifier="check" /> {{ usp }}
    </li>
  </ul>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    usps: Array,
  },
};
</script>

<style scoped>
.usp-list {
  color: #4eab73;
  font-weight: 700;
}

.usp-list__item {
  display: flex;
  align-items: center;
}

.usp-list__item :global(svg) {
  color: currentColor;
  width: 1.25em;
  height: 1.25em;
  margin-right: .375em;
}
</style>
